angular.module('admin.login', []).controller('LoginCtrl', function (
    $state,
    SupervisorResource, 
    UserManager) {
    this.model = {
        email: '',
        password: '',
        remember: false
    };

    this.qrdata = document.location.href.substring(0, document.location.href.indexOf('#'));
    
    this.submit = (frm) => {
        this.submitted = true;
        if(frm.$invalid)
            return;


        delete this.errorMessage;
        SupervisorResource.login(this.model, (data) => {
            UserManager.setCurrent(data, this.model.remember);

            $state.go('admin.home');

        }, (err) => {
            switch(err.status){
                case 400:
                case 401:
                    this.errorMessage = 'Usuário ou senha inválidos! Verifique os dados de acesso e tente novamente!';
                    break;
                case 500:
                    this.errorMessage = 'Ocorreu um erro ao validar seu acesso!';break;
            }
        })

    }

}).config(function ($stateProvider) {
    $stateProvider.state('login', {
        templateUrl: 'views/login/view.html',
        controller: 'LoginCtrl',
        controllerAs: 'ctrl',
        url: '/login'
    });
});